import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinshirur() {



  const cardData =
  {
    keyword: 'Cab Service in Shirur',
    heading: 'Sanavi Travels: Cab Service in Shirur',
    headingDescription: 'Sanavi Travels offers reliable Cab Service in Shirur, providing safe, comfortable, and convenient transportation for local travel, sightseeing trips, outstation journeys, and corporate travel in and around Shirur. Our fleet of well-maintained hatchbacks, sedans, SUVs, and luxury cabs ensures smooth rides, air-conditioning, and ample luggage space for a hassle-free experience. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient doorstep pickup and drop across Shirur, Pune, and nearby areas, making it ideal for family outings, business trips, group travel, and religious visits. Choose Sanavi Travels for trusted cab services in Shirur, delivering comfort, safety, and a seamless travel experience every time.',

    top: 'Top Places to Visit in Shirur with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shirur Town",
    "description": "Shirur is a prominent town in Pune district, situated on the banks of the Ghod River. Known for its historical significance and agricultural surroundings, Shirur serves as a hub for trade, culture, and education in the region. The town offers visitors a blend of rural charm, historical sites, and vibrant local markets."
  },
  {
    "title": "Bhima Ghat Viewpoints",
    "description": "The hills and ghats near Shirur provide stunning viewpoints overlooking the Ghod River and surrounding farmlands. These scenic spots are ideal for nature walks, photography, and enjoying the tranquility of the countryside."
  },
  {
    "title": "Historic Temples of Shirur",
    "description": "Shirur is home to several temples dedicated to Lord Shiva, Lord Ganesh, and local deities. These temples reflect traditional Maharashtrian architecture and serve as focal points for festivals, religious events, and community gatherings."
  },
  {
    "title": "Chintamani Ganpati Temple",
    "description": "A famous local shrine, Chintamani Ganpati Temple attracts devotees from Shirur and nearby villages. Known for its spiritual ambiance and colorful celebrations during Ganesh Chaturthi, the temple is a key religious landmark."
  },
  {
    "title": "Agricultural Lands and Farms",
    "description": "Shirur is surrounded by fertile agricultural lands, primarily cultivating sugarcane, pomegranates, and other crops. Visitors can experience rural life, traditional farming methods, and seasonal harvest festivals in these lush landscapes."
  },
  {
    "title": "Local Markets and Handicrafts",
    "description": "Shirur hosts vibrant weekly markets where locals sell fresh produce, grains, handicrafts, and traditional items. Exploring these markets gives visitors a taste of rural commerce and community culture."
  },
  {
    "title": "Riverfront Areas",
    "description": "The banks of the Ghod River provide peaceful spots for relaxation, picnics, and early morning walks. The riverfront is especially scenic during the monsoon, with flowing water and lush greenery creating a serene environment."
  },
  {
    "title": "Trekking and Hill Walks",
    "description": "Shirur is surrounded by small hills and ghats offering trekking opportunities for beginners and nature enthusiasts. The trails provide panoramic views of the river valleys, farmland, and rural settlements."
  },
  {
    "title": "Historic Sites and Monuments Nearby",
    "description": "The region around Shirur has several historic forts, shrines, and Maratha-era monuments. These sites provide insight into the local history, architecture, and cultural heritage of the Pune district."
  },
  {
    "title": "Local Cuisine and Eateries",
    "description": "Shirur offers authentic Maharashtrian cuisine with local eateries serving traditional meals, snacks, and sweets. Sampling the regional food provides an immersive cultural experience for visitors exploring the town and its surroundings."
  }
]
,



"services": [
{
"name": "Cab Service in Shirur",
"description": "Cab Service in Shirur provides reliable, safe, and comfortable taxi services for local commuting, sightseeing, airport transfers, and outstation trips. With well-maintained vehicles, professional drivers, and timely service, it ensures smooth and hassle-free travel for residents, tourists, families, and corporate clients exploring Shirur and nearby destinations. Ideal for day trips, weekend getaways, and group travel, this service emphasizes convenience, punctuality, and a stress-free journey."
},
{
"name": "Taxi Service Shirur",
"description": "Taxi Service Shirur offers professional and efficient cab solutions for city travel, short-distance rides, and planned excursions. With courteous drivers, transparent pricing, and flexible booking options, it is a preferred choice for residents, tourists, and business travelers looking for reliable and timely transportation within Shirur and surrounding areas."
},
{
"name": "AC Cab Shirur",
"description": "AC Cab Shirur ensures a comfortable and refreshing journey with fully air-conditioned vehicles. Perfect for long-distance trips, corporate travel, family outings, and sightseeing tours, these cabs provide smooth rides, relaxing interiors, and a premium travel experience for all passengers visiting Shirur and nearby locations."
},
{
"name": "Local Cab Shirur",
"description": "Local Cab Shirur offers quick, convenient, and affordable taxi services for city commuting, shopping trips, and local sightseeing. With professional drivers and prompt service, it provides a dependable solution for residents and visitors needing short-distance travel within Shirur town and surrounding areas."
},
{
"name": "Outstation Cab Shirur",
"description": "Outstation Cab Shirur specializes in long-distance taxi services to nearby cities, tourist destinations, and hill stations. Comfortable vehicles, experienced drivers, and flexible itineraries ensure a safe, convenient, and enjoyable journey for families, groups, and solo travelers exploring destinations beyond Shirur."
},
{
"name": "Affordable Cab Shirur",
"description": "Affordable Cab Shirur delivers budget-friendly taxi services without compromising on comfort or safety. Perfect for daily commuters, families, and group travelers, it combines economical pricing with well-maintained vehicles and professional drivers, making it a smart choice for cost-conscious passengers."
},
{
"name": "Chauffeur Driven Cab Shirur",
"description": "Chauffeur Driven Cab Shirur provides trained and professional drivers who handle routes, traffic, and navigation, allowing passengers to relax throughout the journey. Ideal for VIP travel, corporate trips, family outings, and tourist excursions, this service ensures a stress-free, smooth, and enjoyable travel experience."
},
{
"name": "Best Cab Service Shirur",
"description": "Best Cab Service Shirur is known for punctual pickups, clean and well-maintained vehicles, and a customer-focused approach. Suitable for airport transfers, city travel, sightseeing, and outstation trips, it guarantees safe, comfortable, and reliable taxi services every time for individuals, families, and corporate clients."
},
{
"name": "Tourist Cab Shirur",
"description": "Tourist Cab Shirur caters to travelers exploring Shirur and nearby attractions. With flexible itineraries, knowledgeable drivers, and comfortable vehicles, it provides a memorable sightseeing experience, allowing tourists to enjoy cultural sites, scenic locations, and heritage spots without worrying about logistics or navigation."
},
{
"name": "Airport Cab Shirur",
"description": "Airport Cab Shirur offers timely and convenient taxi services for airport pickups and drop-offs. Professional drivers, well-maintained vehicles, and real-time scheduling ensure passengers reach the airport on time and travel comfortably, making it a reliable choice for both domestic and international travelers."
},
{
"name": "Corporate Cab Shirur",
"description": "Corporate Cab Shirur provides professional taxi services for executives, office travel, meetings, and corporate events. With punctual pickups, experienced drivers, and clean vehicles, it ensures efficient, reliable, and stress-free transportation for business purposes in Shirur and nearby areas."
},
{
"name": "Online Cab Booking Shirur",
"description": "Online Cab Booking Shirur allows travelers to reserve cabs quickly and easily with instant confirmation. Multiple vehicle options, transparent pricing, and flexible scheduling make planning trips efficient, hassle-free, and convenient for tourists, corporate clients, and local commuters alike."
},
{
"name": "Family Cab Shirur",
"description": "Family Cab Shirur provides spacious, safe, and comfortable vehicles suitable for family travel. Designed to accommodate all age groups, it ensures a smooth and enjoyable journey for family outings, vacations, and day trips within Shirur and surrounding areas."
},
{
"name": "24x7 Taxi Shirur",
"description": "24x7 Taxi Shirur offers round-the-clock taxi services for emergency travel, late-night pickups, airport transfers, and unplanned trips. With reliable drivers, well-maintained vehicles, and instant availability, it ensures passengers can travel safely and comfortably at any hour."
},
{
"name": "Shirur Travel Taxi",
"description": "Shirur Travel Taxi provides complete taxi solutions for local commuting, tourist travel, and outstation trips. Combining comfort, safety, affordability, and professional service, it caters to residents, tourists, families, and corporate travelers seeking dependable and convenient transportation in Shirur and nearby areas."
}
],
"tableData": [
["Cab Service in Shirur", "Taxi Service Shirur"],
["AC Cab Shirur", "Local Cab Shirur"],
["Outstation Cab Shirur", "Affordable Cab Shirur"],
["Chauffeur Driven Cab Shirur", "Best Cab Service Shirur"],
["Tourist Cab Shirur", "Airport Cab Shirur"],
["Corporate Cab Shirur", "Online Cab Booking Shirur"],
["Family Cab Shirur", "24x7 Taxi Shirur"],
["Shirur Travel Taxi", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Shirur with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services in Shirur for local travel, airport transfers, sightseeing, and outstation trips."
  },
  {
    "WhyChooseheading": "Clean and Well‑Maintained Cabs",
    "WhyChoosedescription": "Our cabs are regularly serviced, air‑conditioned, and kept clean to ensure a smooth and enjoyable ride around Shirur."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Shirur routes, ensuring safe, timely, and stress‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for all cab services in Shirur, including fuel and toll charges, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with cab bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Ride Options",
    "WhyChoosedescription": "Choose from local rides, hourly hires, airport transfers, and outstation cab packages based on your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for cab service in Shirur."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services in Shirur?',
    answer: 'Yes, Sanavi Travels offers dependable cab services in Shirur for local and outstation travel.'
  },
  {
    question: 'How can I book a cab in Shirur?',
    answer: 'You can easily book a cab through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cab services are available in Shirur?',
    answer: 'Sanavi Travels offers local rides, airport transfers, hourly hires, and outstation cab services in Shirur.'
  },
  {
    question: 'Are the drivers experienced with routes in Shirur?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Shirur area and nearby routes.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Shirur.'
  },
  {
    question: 'Is the cab service in Shirur available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock cab services in Shirur to suit your travel schedule.'
  },
  {
    question: 'Are the cabs sanitized before every trip?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for cab services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for cab bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your cab ride in Shirur.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Deshpande',
    feedback: 'Booked a cab in Shirur with Sanavi Travels — excellent service, comfortable ride, and friendly driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Great cab service in Shirur with on‑time pickup and clean vehicle. Highly recommended!',
    rating: 5
  }
];













































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Cab Service in Shirur - Sanavi Travels",
  "description": "Sanavi Travels offers AC, local, and outstation cab services in Shirur for airport transfers, family travel, corporate trips, and tourist journeys. Affordable, reliable, chauffeur-driven taxi service with 24x7 online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "37"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Cab Service in Shirur | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels offers AC, local, and outstation cab services in Shirur for airport transfers, family travel, corporate trips, and tourist journeys. Affordable, reliable, chauffeur-driven taxi service with 24x7 online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/134.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinshirur;